import { Box } from "@mui/material";
import React from "react";
import { LabeledInput } from "../../../UI/LabeledInput";
import { DefaultTax, typeTax } from "../../../../types/budget/service-item";
import ChangelingMonetaryInput from "../../../UI/ChangelingMonetaryInput";
import { useBudget } from "../../../../contexts/BudgetContext/projectbudgets.context";

type Props = {
  title: string;
  previousState: DefaultTax | undefined;
  comparisonState: DefaultTax | undefined;
  type: keyof typeof typeTax;
  calculusOptions: keyValueObj[];
  triggerCalculus(type: string, taxParameters: DefaultTax): void;
  disableChanges: boolean;
  selectedCurrencyCode: string | undefined;
  comparisonCurrencyCode: string | undefined;
  hasTotal?: boolean;
  foreignDecimalScale?: number;
};
type keyValueObj = {
  value: string;
  label: string;
};

const TaxWithConvertedValue: React.FC<Props> = ({
  title,
  previousState,
  comparisonState,
  type,
  calculusOptions,
  triggerCalculus,
  selectedCurrencyCode,
  disableChanges,
  comparisonCurrencyCode,
  hasTotal = true,
  foreignDecimalScale,
}: Props) => {
  const { isLoadingCalcs, negotiationVersion } = useBudget();

  const handleUpdateCalcValues = (
    type: string,
    value: number,
    calcType: string
  ) => {
    // `value` is the user-entered rate/amount; currencyValue/valueBRL are
    // calculated totals filled by calc-methods — do not overwrite them here.
    triggerCalculus(type, {
      ...previousState,
      typeTax: calcType,
      value,
      currencyValue: previousState?.currencyValue ?? 0,
      valueBRL: previousState?.valueBRL ?? 0,
    });
  };

  function calcResultInputValue(
    currencyCode: any,
    referenceValues: DefaultTax | undefined
  ): string {
    const convertedPart = !!currencyCode
      ? `${currencyCode} ${referenceValues?.currencyValue || 0} / `
      : "";
    return convertedPart + `R$ ${referenceValues?.valueBRL || 0}`;
  }
  function defineHelperText(): any {
    if (negotiationVersion < 1) return undefined;

    if (
      comparisonState?.typeTax === "PERCENTAGE" ||
      comparisonState?.typeTax === "PERCENTAGE_RJ"
    )
      return comparisonState?.value + " %";
    else return comparisonState?.value.toString();
  }
  return (
    <Box display={"flex"} gap={3}>
      <ChangelingMonetaryInput
        prevValue={{
          calcType: previousState?.typeTax || "",
          value: previousState?.value ?? 0,
        }}
        label={title}
        type={type}
        calculusOptions={calculusOptions}
        updateCalcValues={handleUpdateCalcValues}
        disabled={disableChanges || isLoadingCalcs}
        helperText={defineHelperText()}
        foreignDecimalScale={foreignDecimalScale}
      />

      {hasTotal && (
        <LabeledInput
          disabled
          label={<span>Total/Total convertido</span>}
          value={calcResultInputValue(selectedCurrencyCode, previousState)}
          helperText={calcResultInputValue(
            comparisonCurrencyCode,
            comparisonState
          )}
        />
      )}
    </Box>
  );
};

export default TaxWithConvertedValue;
